import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Tab,

} from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import {
  Dashboard,
} from "@mui/icons-material";
import ArrowBackButton from "../../../Base/views/ArrowBackButton";
import { isAdminOwner } from "../../../Base/helper/baseFunctions";

import MyReviewPage from "./MyReviewPage";
import TeamReviewPage from "./TeamReview/TeamReviewPage";
import MyReporteesPage from "./MyReporteesPage";
import history from "../../../../../history";

export default function ReviewLandingPage() {

  const [value, setValue] = useState("1");
  
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  
  
 

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[value])
  return (
    <Box sx={{ minHeight: "calc(100vh - 80px)",
                        maxHeight: "calc(100vh - 80px)"}}>
      <Box
        sx={{
          position: "sticky",
          background: "#fff",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <ArrowBackButton
          iconSize={18}
          onClick={() => {
            history.goBack();
          }}
        />
        <Typography
          sx={{
            fontFamily: "Nunito Sans",
            fontWeight: 700,
            color: "#000000",
            fontSize: "1.2rem",
          }}
        >
          Review
        </Typography>
        <Dashboard fontSize="small" />
      </Box>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={handleChange}
              aria-label="lab API tabs example"
              sx={{
                    minHeight: "40px", ".MuiTab-root": { minHeight: "20px" },
                    '& .MuiTabs-indicator': {
                        width: '100%',
                        display: 'flex',
                        justifyContent: "center !important",
                    },
                }}
            >
                <Tab
                  label={
                    <div>
                      {/* <BookmarkBorder style={{ verticalAlign: "middle" }} />  */}
                      My Review
                    </div>
                  }
                  value="1"
                />
                {isAdminOwner() && ( <Tab
                  label={
                    <div>
                      {/* <BackupOutlined style={{ verticalAlign: "middle" }} /> */}
                      My Reportees Review
                    </div>
                  }
                  value="2"
                />)}
                {isAdminOwner() && ( <Tab
                  label={
                    <div>
                      {/* <BackupOutlined style={{ verticalAlign: "middle" }} /> */}
                      Action Required
                    </div>
                  }
                  value="3"
                />)}
            </TabList>
          </Box>
          <TabPanel value="1" sx={{ p: 0 }}>
            <MyReviewPage />
          </TabPanel>
          <TabPanel value="2" sx={{ p: 0 }}>
            <MyReporteesPage />
          </TabPanel>
          <TabPanel value="3" sx={{ p: 0 }} >
            <TeamReviewPage />
          </TabPanel>
        </TabContext>
    </Box>
  );
}

